import { useState, useEffect } from 'react';
import { useCategoriesLogic } from '../../useCategoriesLogic';
import { Row, Col, Spin, List, Space, Button, Affix, Tooltip } from 'antd';
import { SettingOutlined, PlusOutlined } from '@ant-design/icons';
import PageContent from '../../../structure/PageContent';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import EditCategoryModal from './EditCategoryModal';
import CreateCatagoryModal from './CreateCategoryModal';
import { useI18nLocalization } from '../../../i18nLocalization/useI18nLocalization';

const Category = () => {
	const categoryLogic = useCategoriesLogic();

	const [categories, setCategories] = useState(null);
	const [editCategoryModalIsVisible, setEditCategoryModalIsVisible] = useState(false);
	const [createCategoryModalIsVisible, setCreateCategoryModalIsVisible] = useState(false);
	const [selectedCategory, setSelectedCategory] = useState(null);

	const { t } = useI18nLocalization();

	useEffect(() => {
		if (!categories) {
			getCategories();
		}
	}, []);

	const getCategories = async () => {
		const cats = await categoryLogic.getCategories();
		setCategories(cats);
	};

	const onDragEnd = async (result) => {
		if (!result.destination) {
			return;
		} else {
			const catObj = {
				Id: result.draggableId,
				NewIndex: result.destination.index
			};
			updateOrder(catObj);
			reorder(result.source.index, result.destination.index);
		}
	};

	const reorder = (fromIndex, toIndex) => {
		const newOrder = [...categories];
		const removed = newOrder.splice(fromIndex, 1);
		newOrder.splice(toIndex, 0, removed[0]);
		setCategories(newOrder);
	};

	const updateOrder = async (cat) => {
		await categoryLogic.updateCategoryOrder(cat);
		getCategories();
	};

	const getCategoryNames = () => {
		const names = categories.map((cat) => {
			return cat.name;
		});
		return names;
	};

	return !categories ? (
		<Row justify='center' align='middle' style={{ height: '100%' }}>
			<Col>
				<Spin />
			</Col>
		</Row>
	) : (
		<>
			<DragDropContext onDragEnd={onDragEnd}>
				<Droppable droppableId='droppable'>
					{(provided) => (
						<div {...provided.droppableProps} ref={provided.innerRef}>
							<List
								itemLayout='vertical'
								dataSource={categories}
								renderItem={(item) => (
									<Draggable key={item.id} draggableId={item.id} index={item.displayOrder}>
										{(provided) => (
											<div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
												<PageContent className='margin-top-10-px'>
													<List.Item
														key={item.id}
														actions={[
															<Space key={item.id}>
																<Button
																	onClick={() => {
																		setEditCategoryModalIsVisible(true);
																		setSelectedCategory(item);
																	}}
																	type='text'
																	icon={<SettingOutlined />}
																></Button>
																{t('Edit')}
															</Space>
														]}
													>
														<List.Item.Meta title={item.name} />
													</List.Item>
												</PageContent>
											</div>
										)}
									</Draggable>
								)}
							/>
							{provided.placeholder}
						</div>
					)}
				</Droppable>
			</DragDropContext>
			{editCategoryModalIsVisible && (
				<EditCategoryModal
					isVisible={editCategoryModalIsVisible}
					category={selectedCategory}
					onCloseCallback={() => {
						setEditCategoryModalIsVisible(false);
						setSelectedCategory(null);
					}}
					onSaveCallback={() => {
						setEditCategoryModalIsVisible(false);
						setSelectedCategory(null);
						getCategories();
					}}
					categoryNames={getCategoryNames()}
				></EditCategoryModal>
			)}
			<Affix style={{ position: 'fixed', bottom: '7%', right: '2%' }}>
				<span>
					<Tooltip title={t('Add') + ' ' + t('Category')}>
						<Button
							type='primary'
							shape='circle'
							icon={<PlusOutlined />}
							onClick={() => {
								setCreateCategoryModalIsVisible(true);
							}}
						/>
					</Tooltip>
					<CreateCatagoryModal
						isVisible={createCategoryModalIsVisible}
						onCloseCallback={() => {
							setCreateCategoryModalIsVisible(false);
						}}
						onSaveCallback={() => {
							setCreateCategoryModalIsVisible(false);
							getCategories();
						}}
						categoryNames={getCategoryNames()}
					></CreateCatagoryModal>
				</span>
			</Affix>
		</>
	);
};

export default Category;
